import { FieldDataType } from '../enums/FieldDataType';
import {
    validateGridFilterItemValue,
    validateGridFilterItemValue2,
    validateGridFilterItemValues,
} from '../utils/formValidationHelpers';

export type ContactListFilterItem = {
    fieldId: number;
    fieldType: FieldDataType;
    operand: string;
    value: string;
    value2?: string;
    values: string[];
    isMultiselect: boolean;
};

/**
 * buildContactListFilterItem
 *
 * @description
 * Builds an object matching that expected by the Redux store & the server on requests to
 * apply or save filter groups
 */
export function buildContactListFilterItem(args: {
    fieldType: FieldDataType;
    fieldId: number;
    operand: string;
    value: string | number;
    value2: string | number;
    values: string[];
    isMultiselect: boolean;
}): ContactListFilterItem {
    return {
        fieldType: args.fieldType,
        fieldId: args.fieldId,
        operand: args.operand,
        isMultiselect: args.isMultiselect,
        /* 
        TIP: validate value2 before value in cases where value 2 is required but 
        empty (not comparable to value) 
        */
        value2: validateGridFilterItemValue2('value2', args.fieldId, args.operand, args.value2),
        value: validateGridFilterItemValue(
            'value',
            args.fieldId,
            args.fieldType,
            args.operand,
            args.value as number,
            args.value2 as number,
        ),
        values: validateGridFilterItemValues(
            'values',
            args.fieldId, // required for withCatchFormErrorMultiField to work
            args.fieldType,
            args.values as string[],
        ),
    };
}
